import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem'; 
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputRedeFranquia = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { franchise } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("franchise")
    }

    return (
        <CampoInputTexto
            id="inputRedeFranquia"
            titulo="Rede franquia"
            onChange={handleChange}
            name="franchise"
            value={franchise}
            disabled={disabled}
            >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputRedeFranquia
